/* eslint-disable max-lines */
export const STATES = [
  {
    stateName: 'Южный',
    regions: [
      {
        regionName: 'Астраханская',
        citiesList: [
          {
            cityName: 'Астрахань',
            routeName: '/astrakhan/nannies/',
          },
        ],
      },
      {
        regionName: 'Волгоградская',
        citiesList: [
          {
            cityName: 'Волгоград',
            routeName: '/volgograd/nannies/',
          },
          {
            cityName: 'Волжский',
            routeName: '/volzhsky/nannies/',
          },
          {
            cityName: 'Камышин',
            routeName: '/kamyshin/nannies/',
          },
        ],
      },
      {
        regionName: 'Кабардино-Балкарская  ',
        citiesList: [
          {
            cityName: 'Нальчик',
            routeName: '/nalchik/nannies/',
          },
        ],
      },
      {
        regionName: 'Карачаево-Черкесская  ',
        citiesList: [
          {
            cityName: 'Черкесск',
            routeName: '/cherkessk/nannies/',
          },
        ],
      },
      {
        regionName: 'Краснодарский край',
        citiesList: [
          {
            cityName: 'Армавир',
            routeName: '/armavir/nannies/',
          },
          {
            cityName: 'Краснодар',
            routeName: '/krasnodar/nannies/',
          },
          {
            cityName: 'Новороссийск',
            routeName: '/novorossiysk/nannies/',
          },
          {
            cityName: 'Сочи',
            routeName: '/sochi/nannies/',
          },
        ],
      },
      {
        regionName: 'Адыгея',
        citiesList: [
          {
            cityName: 'Майкоп',
            routeName: '/maykop/nannies/',
          },
        ],
      },
      {
        regionName: 'Дагестан',
        citiesList: [
          {
            cityName: 'Каспийск',
            routeName: '/kaspiysk/nannies/',
          },
          {
            cityName: 'Махачкала',
            routeName: '/makhachkala/nannies/',
          },
        ],
      },
      {
        regionName: 'Калмыкия',
        citiesList: [
          {
            cityName: 'Элиста',
            routeName: '/elista/nannies/',
          },
        ],
      },
      {
        regionName: 'Северная Осетия — Алания',
        citiesList: [
          {
            cityName: 'Владикавказ',
            routeName: '/vladikavkaz/nannies/',
          },
        ],
      },
      {
        regionName: 'Ростовская',
        citiesList: [
          {
            cityName: 'Батайск',
            routeName: '/bataysk/nannies/',
          },
          {
            cityName: 'Волгодонск',
            routeName: '/volgodonsk/nannies/',
          },
          {
            cityName: 'Новочеркасск',
            routeName: '/novocherkassk/nannies/',
          },
          {
            cityName: 'Новошахтинск',
            routeName: '/novoshakhtinsk/nannies/',
          },
          {
            cityName: 'Ростов-на-Дону',
            routeName: '/rostov-na-donu/nannies/',
          },
          {
            cityName: 'Таганрог',
            routeName: '/taganrog/nannies/',
          },
          {
            cityName: 'Шахты',
            routeName: '/shakhty/nannies/',
          },
        ],
      },
      {
        regionName: 'Ставропольский край',
        citiesList: [
          {
            cityName: 'Ессентуки',
            routeName: '/essentuki/nannies/',
          },
          {
            cityName: 'Кисловодск',
            routeName: '/kislovodsk/nannies/',
          },
          {
            cityName: 'Невинномысск',
            routeName: '/nevinnomyssk/nannies/',
          },
          {
            cityName: 'Пятигорск',
            routeName: '/pyatigorsk/nannies/',
          },
          {
            cityName: 'Ставрополь',
            routeName: '/stavropol/nannies/',
          },
        ],
      },
    ],
  },
  {
    stateName: 'Центральный',
    regions: [
      {
        regionName: 'Москва',
        citiesList: [
          {
            cityName: 'Москва',
            routeName: '/',
          },
        ],
      },
      {
        regionName: 'Белгородская',
        citiesList: [
          {
            cityName: 'Белгород',
            routeName: '/belgorod/nannies/',
          },
          {
            cityName: 'Старый Оскол',
            routeName: '/stary_oskol/nannies/',
          },
        ],
      },
      {
        regionName: 'Брянская',
        citiesList: [
          {
            cityName: 'Брянск',
            routeName: '/bryansk/nannies/',
          },
        ],
      },
      {
        regionName: 'Владимирская',
        citiesList: [
          {
            cityName: 'Владимир',
            routeName: '/vladimir/nannies/',
          },
          {
            cityName: 'Ковров',
            routeName: '/kovrov/nannies/',
          },
          {
            cityName: 'Муром',
            routeName: '/murom/nannies/',
          },
        ],
      },
      {
        regionName: 'Воронежская',
        citiesList: [
          {
            cityName: 'Воронеж',
            routeName: '/voronezh/nannies/',
          },
        ],
      },
      {
        regionName: 'Ивановская',
        citiesList: [
          {
            cityName: 'Иваново',
            routeName: '/ivanovo/nannies/',
          },
        ],
      },
      {
        regionName: 'Калужская',
        citiesList: [
          {
            cityName: 'Калуга',
            routeName: '/kaluga/nannies/',
          },
          {
            cityName: 'Обнинск',
            routeName: '/obninsk/nannies/',
          },
        ],
      },
      {
        regionName: 'Курская',
        citiesList: [
          {
            cityName: 'Курск',
            routeName: '/kursk/nannies/',
          },
        ],
      },
      {
        regionName: 'Липецкая',
        citiesList: [
          {
            cityName: 'Елец',
            routeName: '/yelets/nannies/',
          },
          {
            cityName: 'Липецк',
            routeName: '/lipetsk/nannies/',
          },
        ],
      },
      {
        regionName: 'Московская',
        citiesList: [
          {
            cityName: 'Балашиха',
            routeName: '/balashikha/nannies/',
          },
          {
            cityName: 'Долгопрудный',
            routeName: '/dolgoprudny/nannies/',
          },
          {
            cityName: 'Домодедово',
            routeName: '/domodedovo/nannies/',
          },
          {
            cityName: 'Жуковский',
            routeName: '/zhukovsky/nannies/',
          },
          {
            cityName: 'Ивантеевка',
            routeName: '/ivanteevka/nannies/',
          },
          {
            cityName: 'Коломна',
            routeName: '/kolomna/nannies/',
          },
          {
            cityName: 'Королёв',
            routeName: '/korolev/nannies/',
          },
          {
            cityName: 'Красногорск',
            routeName: '/krasnogorsk/nannies/',
          },
          {
            cityName: 'Краснознаменск',
            routeName: '/krasnoznamensk/nannies/',
          },
          {
            cityName: 'Люберцы',
            routeName: '/lyubertsy/nannies/',
          },
          {
            cityName: 'Мытищи',
            routeName: '/mytishchi/nannies/',
          },
          {
            cityName: 'Ногинск',
            routeName: '/noginsk/nannies/',
          },
          {
            cityName: 'Одинцово',
            routeName: '/odintsovo/nannies/',
          },
          {
            cityName: 'Орехово-Зуево',
            routeName: '/orekhovo-zuevo/nannies/',
          },
          {
            cityName: 'Подольск',
            routeName: '/podolsk/nannies/',
          },
          {
            cityName: 'Пушкино',
            routeName: '/pushkino/nannies/',
          },
          {
            cityName: 'Раменское',
            routeName: '/ramenskoye/nannies/',
          },
          {
            cityName: 'Реутов',
            routeName: '/reutov/nannies/',
          },
          {
            cityName: 'Сергиев Посад',
            routeName: '/sergiev_posad/nannies/',
          },
          {
            cityName: 'Серпухов',
            routeName: '/serpukhov/nannies/',
          },
          {
            cityName: 'Химки',
            routeName: '/khimki/nannies/',
          },
          {
            cityName: 'Щёлково',
            routeName: '/shchelkovo/nannies/',
          },
          {
            cityName: 'Электросталь',
            routeName: '/elektrostal/nannies/',
          },
          {
            cityName: 'Электроугли',
            routeName: '/elektrougli/nannies/',
          },
        ],
      },
      {
        regionName: 'Орловская',
        citiesList: [
          {
            cityName: 'Орёл',
            routeName: '/orel/nannies/',
          },
        ],
      },
      {
        regionName: 'Рязанская',
        citiesList: [
          {
            cityName: 'Рязань',
            routeName: '/ryazan/nannies/',
          },
        ],
      },
      {
        regionName: 'Смоленская',
        citiesList: [
          {
            cityName: 'Смоленск',
            routeName: '/smolensk/nannies/',
          },
        ],
      },
      {
        regionName: 'Тамбовская',
        citiesList: [
          {
            cityName: 'Тамбов',
            routeName: '/tambov/nannies/',
          },
        ],
      },
      {
        regionName: 'Тверская',
        citiesList: [
          {
            cityName: 'Тверь',
            routeName: '/tver/nannies/',
          },
        ],
      },
      {
        regionName: 'Тульская',
        citiesList: [
          {
            cityName: 'Новомосковск',
            routeName: '/novomoskovsk/nannies/',
          },
          {
            cityName: 'Тула',
            routeName: '/tula/nannies/',
          },
        ],
      },
      {
        regionName: 'Ярославская',
        citiesList: [
          {
            cityName: 'Рыбинск',
            routeName: '/rybinsk/nannies/',
          },
          {
            cityName: 'Ярославль',
            routeName: '/yaroslavl/nannies/',
          },
        ],
      },
    ],
  },
  {
    stateName: 'Приволжский',
    regions: [
      {
        regionName: 'Кировская',
        citiesList: [
          {
            cityName: 'Киров',
            routeName: '/kirov/nannies/',
          },
        ],
      },
      {
        regionName: 'Нижегородская',
        citiesList: [
          {
            cityName: 'Арзамас',
            routeName: '/arzamas/nannies/',
          },
          {
            cityName: 'Дзержинск',
            routeName: '/dzerzhinsk/nannies/',
          },
          {
            cityName: 'Нижний Новгород',
            routeName: '/nizhny_novgorod/nannies/',
          },
        ],
      },
      {
        regionName: 'Оренбургская',
        citiesList: [
          {
            cityName: 'Оренбург',
            routeName: '/orenburg/nannies/',
          },
          {
            cityName: 'Орск',
            routeName: '/orsk/nannies/',
          },
        ],
      },
      {
        regionName: 'Пензенская',
        citiesList: [
          {
            cityName: 'Пенза',
            routeName: '/penza/nannies/',
          },
        ],
      },
      {
        regionName: 'Пермский край',
        citiesList: [
          {
            cityName: 'Березники',
            routeName: '/berezniki/nannies/',
          },
          {
            cityName: 'Пермь',
            routeName: '/perm/nannies/',
          },
        ],
      },
      {
        regionName: 'Башкортостан',
        citiesList: [
          {
            cityName: 'Благовещенск (Башкортостан)',
            routeName: '/bashkortostan_blagoveshchensk/nannies/',
          },
          {
            cityName: 'Ишимбай',
            routeName: '/ishimbay/nannies/',
          },
          {
            cityName: 'Нефтекамск',
            routeName: '/neftekamsk/nannies/',
          },
          {
            cityName: 'Октябрьский',
            routeName: '/oktyabrsky/nannies/',
          },
          {
            cityName: 'Салават',
            routeName: '/salavat/nannies/',
          },
          {
            cityName: 'Стерлитамак',
            routeName: '/sterlitamak/nannies/',
          },
          {
            cityName: 'Уфа',
            routeName: '/ufa/nannies/',
          },
        ],
      },
      {
        regionName: 'Марий Эл',
        citiesList: [
          {
            cityName: 'Йошкар-Ола',
            routeName: '/yoshkar-ola/nannies/',
          },
        ],
      },
      {
        regionName: 'Мордовия',
        citiesList: [
          {
            cityName: 'Саранск',
            routeName: '/saransk/nannies/',
          },
        ],
      },
      {
        regionName: 'Татарстан',
        citiesList: [
          {
            cityName: 'Альметьевск',
            routeName: '/almetyevsk/nannies/',
          },
          {
            cityName: 'Зеленодольск',
            routeName: '/zelenodolsk/nannies/',
          },
          {
            cityName: 'Казань',
            routeName: '/kazan/nannies/',
          },
          {
            cityName: 'Набережные Челны',
            routeName: '/naberezhnye_chelny/nannies/',
          },
          {
            cityName: 'Нижнекамск',
            routeName: '/nizhnekamsk/nannies/',
          },
        ],
      },
      {
        regionName: 'Самарская',
        citiesList: [
          {
            cityName: 'Новокуйбышевск',
            routeName: '/novokuybyshevsk/nannies/',
          },
          {
            cityName: 'Самара',
            routeName: '/samara/nannies/',
          },
          {
            cityName: 'Сызрань',
            routeName: '/syzran/nannies/',
          },
          {
            cityName: 'Тольятти',
            routeName: '/tolyatti/nannies/',
          },
        ],
      },
      {
        regionName: 'Саратовская',
        citiesList: [
          {
            cityName: 'Балаково',
            routeName: '/balakovo/nannies/',
          },
          {
            cityName: 'Саратов',
            routeName: '/saratov/nannies/',
          },
          {
            cityName: 'Энгельс',
            routeName: '/engels/nannies/',
          },
        ],
      },
      {
        regionName: 'Удмуртская  ',
        citiesList: [
          {
            cityName: 'Ижевск',
            routeName: '/izhevsk/nannies/',
          },
        ],
      },
      {
        regionName: 'Ульяновская',
        citiesList: [
          {
            cityName: 'Димитровград',
            routeName: '/dimitrovgrad/nannies/',
          },
          {
            cityName: 'Ульяновск',
            routeName: '/ulyanovsk/nannies/',
          },
        ],
      },
      {
        regionName: 'Чувашия',
        citiesList: [
          {
            cityName: 'Новочебоксарск',
            routeName: '/novocheboksarsk/nannies/',
          },
          {
            cityName: 'Чебоксары',
            routeName: '/cheboksary/nannies/',
          },
        ],
      },
    ],
  },
  {
    stateName: 'Северо-Западный',
    regions: [
      {
        regionName: 'Санкт-Петербург',
        citiesList: [
          {
            cityName: 'Санкт-Петербург',
            routeName: '/spb/nannies/',
          },
        ],
      },
      {
        regionName: 'Архангельская',
        citiesList: [
          {
            cityName: 'Архангельск',
            routeName: '/arkhangelsk/nannies/',
          },
          {
            cityName: 'Северодвинск',
            routeName: '/severodvinsk/nannies/',
          },
        ],
      },
      {
        regionName: 'Вологодская',
        citiesList: [
          {
            cityName: 'Вологда',
            routeName: '/vologda/nannies/',
          },
          {
            cityName: 'Череповец',
            routeName: '/cherepovets/nannies/',
          },
        ],
      },
      {
        regionName: 'Калининградская',
        citiesList: [
          {
            cityName: 'Калининград',
            routeName: '/kaliningrad/nannies/',
          },
        ],
      },
      {
        regionName: 'Мурманская',
        citiesList: [
          {
            cityName: 'Мурманск',
            routeName: '/murmansk/nannies/',
          },
        ],
      },
      {
        regionName: 'Новгородская',
        citiesList: [
          {
            cityName: 'Великий Новгород',
            routeName: '/velikiy_novgorod/nannies/',
          },
        ],
      },
      {
        regionName: 'Псковская',
        citiesList: [
          {
            cityName: 'Псков',
            routeName: '/pskov/nannies/',
          },
        ],
      },
      {
        regionName: 'Карелия',
        citiesList: [
          {
            cityName: 'Петрозаводск',
            routeName: '/petrozavodsk/nannies/',
          },
        ],
      },
      {
        regionName: 'Коми',
        citiesList: [
          {
            cityName: 'Сыктывкар',
            routeName: '/syktyvkar/nannies/',
          },
        ],
      },
    ],
  },
  {
    stateName: 'Уральский',
    regions: [
      {
        regionName: 'Курганская',
        citiesList: [
          {
            cityName: 'Курган',
            routeName: '/kurgan/nannies/',
          },
        ],
      },
      {
        regionName: 'Свердловская',
        citiesList: [
          {
            cityName: 'Екатеринбург',
            routeName: '/yekaterinburg/nannies/',
          },
          {
            cityName: 'Каменск-Уральский',
            routeName: '/kamensk-uralsky/nannies/',
          },
          {
            cityName: 'Нижний Тагил',
            routeName: '/nizhny_tagil/nannies/',
          },
          {
            cityName: 'Первоуральск',
            routeName: '/pervouralsk/nannies/',
          },
        ],
      },
      {
        regionName: 'Тюменская',
        citiesList: [
          {
            cityName: 'Тюмень',
            routeName: '/tyumen/nannies/',
          },
        ],
      },
      {
        regionName: 'Ханты-Мансийский автономный округ',
        citiesList: [
          {
            cityName: 'Нижневартовск',
            routeName: '/nizhnevartovsk/nannies/',
          },
          {
            cityName: 'Сургут',
            routeName: '/surgut/nannies/',
          },
          {
            cityName: 'Ханты-Мансийск',
            routeName: '/khanty-mansiysk/nannies/',
          },
        ],
      },
      {
        regionName: 'Челябинская',
        citiesList: [
          {
            cityName: 'Златоуст',
            routeName: '/zlatoust/nannies/',
          },
          {
            cityName: 'Копейск',
            routeName: '/kopeysk/nannies/',
          },
          {
            cityName: 'Магнитогорск',
            routeName: '/magnitogorsk/nannies/',
          },
          {
            cityName: 'Миасс',
            routeName: '/miass/nannies/',
          },
          {
            cityName: 'Челябинск',
            routeName: '/chelyabinsk/nannies/',
          },
        ],
      },
      {
        regionName: 'Ямало-Ненецкий автономный округ',
        citiesList: [
          {
            cityName: 'Новый Уренгой',
            routeName: '/novy_urengoy/nannies/',
          },
          {
            cityName: 'Ноябрьск',
            routeName: '/noyabrsk/nannies/',
          },
        ],
      },
    ],
  },
  {
    stateName: 'Сибирский',
    regions: [
      {
        regionName: 'Алтайский край',
        citiesList: [
          {
            cityName: 'Барнаул',
            routeName: '/barnaul/nannies/',
          },
          {
            cityName: 'Бийск',
            routeName: '/biysk/nannies/',
          },
          {
            cityName: 'Рубцовск',
            routeName: '/rubtsovsk/nannies/',
          },
        ],
      },
      {
        regionName: 'Иркутская',
        citiesList: [
          {
            cityName: 'Ангарск',
            routeName: '/angarsk/nannies/',
          },
          {
            cityName: 'Братск',
            routeName: '/bratsk/nannies/',
          },
          {
            cityName: 'Иркутск',
            routeName: '/irkutsk/nannies/',
          },
        ],
      },
      {
        regionName: 'Кемеровская',
        citiesList: [
          {
            cityName: 'Кемерово',
            routeName: '/kemerovo/nannies/',
          },
          {
            cityName: 'Новокузнецк',
            routeName: '/novokuznetsk/nannies/',
          },
          {
            cityName: 'Прокопьевск',
            routeName: '/prokopyevsk/nannies/',
          },
        ],
      },
      {
        regionName: 'Красноярский край',
        citiesList: [
          {
            cityName: 'Ачинск',
            routeName: '/achinsk/nannies/',
          },
          {
            cityName: 'Железногорск',
            routeName: '/zheleznogorsk/nannies/',
          },
          {
            cityName: 'Красноярск',
            routeName: '/krasnoyarsk/nannies/',
          },
          {
            cityName: 'Норильск',
            routeName: '/norilsk/nannies/',
          },
        ],
      },
      {
        regionName: 'Новосибирская',
        citiesList: [
          {
            cityName: 'Бердск',
            routeName: '/berdsk/nannies/',
          },
          {
            cityName: 'Новосибирск',
            routeName: '/novosibirsk/nannies/',
          },
        ],
      },
      {
        regionName: 'Омская',
        citiesList: [
          {
            cityName: 'Омск',
            routeName: '/omsk/nannies/',
          },
        ],
      },
      {
        regionName: 'Бурятия',
        citiesList: [
          {
            cityName: 'Улан-Удэ',
            routeName: '/ulan-ude/nannies/',
          },
        ],
      },
      {
        regionName: 'Тыва',
        citiesList: [
          {
            cityName: 'Кызыл',
            routeName: '/kyzyl/nannies/',
          },
        ],
      },
      {
        regionName: 'Хакасия',
        citiesList: [
          {
            cityName: 'Абакан',
            routeName: '/abakan/nannies/',
          },
        ],
      },
      {
        regionName: 'Томская',
        citiesList: [
          {
            cityName: 'Томск',
            routeName: '/tomsk/nannies/',
          },
        ],
      },
    ],
  },
  {
    stateName: 'Дальневосточный',
    regions: [
      {
        regionName: 'Амурская',
        citiesList: [
          {
            cityName: 'Благовещенск',
            routeName: '/amur_region_blagoveshchensk/nannies/',
          },
        ],
      },
      {
        regionName: 'Забайкальский край',
        citiesList: [
          {
            cityName: 'Чита',
            routeName: '/chita/nannies/',
          },
        ],
      },
      {
        regionName: 'Камчатский край',
        citiesList: [
          {
            cityName: 'Петропавловск-Камчатский',
            routeName: '/petropavlovsk-kamchatsky/nannies/',
          },
        ],
      },
      {
        regionName: 'Приморский край',
        citiesList: [
          {
            cityName: 'Артем',
            routeName: '/artyom/nannies/',
          },
          {
            cityName: 'Владивосток',
            routeName: '/vladivostok/nannies/',
          },
          {
            cityName: 'Находка',
            routeName: '/nakhodka/nannies/',
          },
          {
            cityName: 'Уссурийск',
            routeName: '/ussuriysk/nannies/',
          },
        ],
      },
      {
        regionName: 'Саха (Якутия)',
        citiesList: [
          {
            cityName: 'Якутск',
            routeName: '/yakutsk/nannies/',
          },
        ],
      },
      {
        regionName: 'Сахалинская',
        citiesList: [
          {
            cityName: 'Южно-Сахалинск',
            routeName: '/yuzhno-sakhalinsk/nannies/',
          },
        ],
      },
      {
        regionName: 'Хабаровский край',
        citiesList: [
          {
            cityName: 'Комсомольск-на-Амуре',
            routeName: '/komsomolsk-na-amure/nannies/',
          },
          {
            cityName: 'Хабаровск',
            routeName: '/khabarovsk/nannies/',
          },
        ],
      },
    ],
  },
];
